import { useNavigate, useParams } from "react-router";
import AssetFleetProcessingBreadcrumb from "./AssetFleetProcessingBreadcrumb"
import { GetStatusIcon } from "client/utils/IconsUtil";
import navOperations from "redux/Navigation/operations";
import { useDispatch, useSelector } from "react-redux";
import selectors from "redux/Navigation/selectors";
import { useCallback } from "react";

const AssetFleetProcessingBreadcrumbContainer = () => {

    const navigate = useNavigate();
    const dispatch = useDispatch();
    const dispatchNav = navOperations.dispatchNav(dispatch);
    const {
        savedStatus,
        headerNav,
        assetOrderHeaderDetail
      }: any = useSelector((state?: any) => ({
        savedStatus: state.adminTaskReducer.savedStatus,
        headerNav: selectors.GetHeaderNav(state),
        assetOrderHeaderDetail: state.AssetFleetProcessingReducer.assetOrderHeaderDetail
    }))

    let {pagename, activeassetnumber} = useParams();

    const breadcrumlist = [
        {
          text: pagename == 'activeasset' ? "Active Assets Drill Through" : headerNav === "Asset " ? "Asset " : headerNav,
          key: "f1",
          href: "/ordermanagement",
          onClick: (e: any) => {
            e.preventDefault();
            if(pagename == 'activeasset'){
              navigate('/ordermanagement/activeasset/activeassetdashboard/' + activeassetnumber)
            }else{
            dispatchNav("Home");
            navigate('/ordermanagement');
            }
          },
        },
        { text: "Purchase Order", key: "f2" },
    ];

    const onClickBack = () => {
      if(pagename == 'activeasset'){
        navigate('/ordermanagement/activeasset/activeassetdashboard/' + activeassetnumber)
      }else{
      dispatchNav("Home");
      navigate('/ordermanagement');
      }
    }

    const iconReturn = (status: any) => {
        return <img src={GetStatusIcon(status).icon} alt="statusIcon" className="statusIcon" />;
    };
    
  const getOrderStatus = useCallback((valType: any) => {
      if (valType == "icon") {
        return iconReturn(assetOrderHeaderDetail?.orderStatus)
      } else {
        return (assetOrderHeaderDetail?.orderStatus)
      }
  }, [assetOrderHeaderDetail, savedStatus])
  
    return(
        <AssetFleetProcessingBreadcrumb breadcrumlist={breadcrumlist} getOrderStatus={getOrderStatus} onClickBack={onClickBack}
        />
    )
}

export default AssetFleetProcessingBreadcrumbContainer